"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delete_all_bidders = void 0;
var api_1 = require("../../../api");
var delete_all_bidders = function (req) {
    return (0, api_1.apiDelete)({
        endpoint: "v3/bidder/delete_all_bidders",
        data: req,
    });
};
exports.delete_all_bidders = delete_all_bidders;
